module.exports = __webpack_public_path__ + "static/media/listAlarmas.ae61584d.png";